<template>
  <div class="home_index">
    <!--这里是home首页,就一个<i class="iconfont icon-home"></i>图标什么都没有,到时要放什么再填充-->
    <div class="home_index_first">
      <div class="home_index_img">
        <img src="../../assets/img/pg_person.png"/>
        <!--<img src="../../assets/img/bg_login.jpg"/>-->
      </div>
      <div class="home_index_account ml20">
        <div class="fs18 fwb mb30">{{userName}}
          <button class="btn btn_normal ml20"
                  v-if="!msg.AoccountInfo.IsAutoPay"
                  @click="isOpenAutomaticPayment(1)">开启自动付款</button>
          <button class="btn btn_cancel ml20"
                  v-if="msg.AoccountInfo.IsAutoPay"
                  @click="isOpenAutomaticPayment(2)">关闭自动付款</button>
        </div>
        <div class="mb20">余额：<i class="fs18 fwb">{{msg.AoccountInfo.Balance}}</i>元  <button class="btn_normal ml20" @click="toRecharge()">充值</button></div>
        <div class="mb15">待审核充值工单：<a class="fcBlue" title="待审核" @click="toOrderRecharge(1)">{{msg.AoccountInfo.ToCheckRechargeCount}}笔</a></div>
        <div>被拒绝充值工单：<a class="fcBlue" title="被拒绝" @click="toOrderRecharge(3)">{{msg.AoccountInfo.RejectRechargeCount}}笔</a></div>
      </div>
    </div>

    <div class="home_index_second">
      <div class="home_index_second_left">
        <div class="inb arrow arrow_left">
          <div class="fwb">
            <!--订-->
          </div>
        </div>
        <div class="inb">
          <p><span>待审核订单：</span><a class="fcBlue" title="待审核" @click="toOrder(1)">{{msg.OrderInfo.ToCheckCount}}笔</a></p>
          <p><span>待付款订单：</span><a class="fcBlue" title="待付款" @click="toOrder(2)">{{msg.OrderInfo.ToPayCount}}笔</a></p>
          <p><span>部分发货订单：</span><a class="fcBlue" title="部分发货" @click="toOrder(6)">{{msg.OrderInfo.PartSendCout}}笔</a></p>
          <p><span>整单缺货订单：</span><a class="fcBlue" title="整单缺货" @click="toOrder(7)">{{msg.OrderInfo.LackSendCount}}笔</a></p>
          <p><span>空仓订单：</span><a class="fcBlue" title="空仓订单" @click="toOrder(-1)">{{msg.OrderInfo.EmptyStoreroomCount}}笔</a></p>
        </div>
      </div>
      <div class="home_index_second_right">
        <div class="inb arrow arrow_right">
          <div class="fwb">
            <!--售-->
          </div>
        </div>
        <div class="inb">
          <p><span>待受理售后单：</span><a class="fcBlue" title="待受理" @click="toAfterSalesOrder(2)">{{msg.RefundInfo.PendingRefundCount}}笔</a></p>
          <p><span>被拒绝售后单：</span><a class="fcBlue" title="被拒绝" @click="toAfterSalesOrder(6)">{{msg.RefundInfo.RejectRefundCount}}笔</a></p>
          <p><span>待审核申诉工单：</span><a class="fcBlue" title="待审核申诉" @click="toComplaintOrder(2)">{{msg.RefundInfo.ToCheckWorkOrderCount}}笔</a></p>
          <p><span>被拒绝申诉工单：</span><a class="fcBlue" title="被拒绝申诉" @click="toComplaintOrder(4)">{{msg.RefundInfo.RejectWorkOrderCount}}笔</a></p>
        </div>
      </div>
    </div>

    <div class="home_index_third">
      <div class="home_index_third_left">
        <!--<div class="left_top"></div>-->
        <!--<div class="right_top"></div>-->
        <!--<div class="left_bottom"></div>-->
        <!--<div class="right_bottom"></div>-->
        <div class="title"><span class="fs18 fwb">平台公告</span><a class="fr fcBlue" title="更多"  @click="toPlatformList(null, -1)">更多>></a></div>
        <ul>
          <li v-for="(item, index) in msg.PFNotice" :key="index" @click="toPlatformList(item.Id, item.Title)">{{item.PubTime | timeday}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.Title}}</li>
         <!-- <li>2019/03/26&nbsp;&nbsp;&nbsp;&nbsp;仓库放假</li>
          <li>2019/03/26&nbsp;&nbsp;&nbsp;&nbsp;仓库放假</li>
          <li>2019/03/26&nbsp;&nbsp;&nbsp;&nbsp;仓库放假</li>
          <li>2019/03/26&nbsp;&nbsp;&nbsp;&nbsp;仓库放假</li> -->
        </ul>
      </div>
      <div class="home_index_third_right">
        <!--<div class="left_top"></div>-->
        <!--<div class="right_top"></div>-->
        <!--<div class="left_bottom"></div>-->
        <!--<div class="right_bottom"></div>-->
        <div class="title"><span class="fs18 fwb">供应商公告</span> <a class="fr fcBlue" title="更多" @click="toSupplierList(null, -1)">更多>></a></div>
        <ul>
          <li v-for="(item, index) in msg.SPNotice" :key="index" @click="toSupplierList(item.Id, item.Title)">{{item.PubTime | timeday}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.Title}} <span class="fr">{{item.ClientIdAndName}}</span></li>
        </ul>
      </div>
    </div>

    <!--弹出框-->
    <index-embed-msg v-if="isShow"
                     :title="dialogTitle"
                     :msg="dialogMsg"
                     @cancelbtn="getSelectDialogEmbed"></index-embed-msg>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script>
  import IndexEmbedMsg from './index-embed-msg';
  import LoadingDialog from '../public-component/loading-dialog';
  import MsgDialog from '../public-component/msg-dialog';

  export default {
    name: 'index',
    components: {IndexEmbedMsg, LoadingDialog, MsgDialog},
    computed: {
      rightTabsContent: {
        // getter
        get: function () {
          return this.$store.state.tabs;
        },
        // setter
        set: function (newVal) {
          this.$store.state.tabs = newVal;
          return this.$store.state.tabs;
        }
      },
      rightTabsPosition: {
        get: function () {
          return this.$store.state.tabsPosition;
        },
        set: function (newVal) {
          this.$store.state.tabsPosition = newVal;
          return this.$store.state.tabsPosition;
        }
      }
    },
    data() {
      return {
        userName: null, // 用户名
        msg: {
          AoccountInfo: {
            Balance: null, // 账号余额
            ToCheckRechargeCount: null, // 待审核充值工单
            RejectRechargeCount: null, // 被拒绝充值工单
            IsAutoPay: 2 // 是否开启自动付款  1开启；2关闭
          },
          OrderInfo: {
            ToCheckCount: null, // 待审核订单数量
            ToPayCount: null, // 待付款订单数量
            PartSendCout: null, // 部分发货数量
            LackSendCount: null, // 整单缺货订单数量
            EmptyStoreroomCount: null // 空仓订单数量
          },
          RefundInfo: {
            PendingRefundCount: null, // 待受理售后单
            RejectRefundCount: null, // 被拒绝售后单
            ToCheckWorkOrderCount: null, // 待审核申诉工单
            RejectWorkOrderCount: null // 被拒绝申诉工单
          },
          PFNotice: [], // { Id: null, Title: null, PubTime: null }
          SPNotice: [] // { Id: null, Title: null, PubTime: null, ClientIdAndName: "xmcp_厦门畅跑" }
        },
        isShow: false, // 提示框显示
        dialogTitle: false, // 弹出框头部名
        dialogMsg: false, // 传入内容
        isLoading: false, // 是否显示登录超时框
        loadingType: 'NOP', // 加载类型  NOP=空操作，用于加载  loginTimeout=加载超时
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容' // 信息框内容
      }
    },
    methods: {
      // 获取分销商的主信息
      getAgentMainInfo() {
        this.isLoading = true;
        this.$axios.get(this.Global.getAgentMainInfo).then(res => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.msg = res.data.resData;
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      isOpenAutomaticPayment(type) {
        this.isShow = true;
        this.dialogTitle = '提示';
        this.dialogMsg = type;
      },

      // 充值
      toRecharge() {
        this.$router.push({
          path: '/home/a_recharge'
        });
        let index = -1;
        index = this.rightTabsContent.findIndex(item => {
          return item.title === '账户充值';
        });
        if (index === -1) {
          this.rightTabsContent.push({
            title: '账户充值',
            name: '/home/a_recharge',
            content: this.$route.fullPath
          });
        } else {
          this.rightTabsContent.splice(index, 1, {
            title: '账户充值',
            name: '/home/a_recharge/home/a_recharge',
            content: this.$route.fullPath
          });
        }
        this.rightTabsPosition = '/home/a_recharge';
        this.$store.commit('updateTabs', this.rightTabsContent);
        this.$store.commit('updateTabsPosition', this.rightTabsPosition);
      },

      // 充值工单
      toOrderRecharge(status) { // status  1=待审核  2=已审核  3=拒绝审核
        this.$router.push({
          path: '/home/recharge_order',
          query: {
            status: status
          }
        });
        let index = -1;
        index = this.rightTabsContent.findIndex(item => {
          return item.title === '充值工单管理';
        });
        if (index === -1) {
          this.rightTabsContent.push({
            title: '充值工单管理',
            name: '/home/recharge_order',
            content: this.$route.fullPath
          });
        } else {
          this.rightTabsContent.splice(index, 1, {
            title: '充值工单管理',
            name: '/home/recharge_order',
            content: this.$route.fullPath
          });
        }
        this.rightTabsPosition = '/home/recharge_order';
        this.$store.commit('updateTabs', this.rightTabsContent);
        this.$store.commit('updateTabsPosition', this.rightTabsPosition);
      },

      // 订单 status  1=待审  2=待付款  3=已付款  4=待发货＝》配货中  5=已发货  6=部分发货  7=整单缺货  8=交易完成  9=交易取消  -1=空仓
      toOrder(status) {
        this.$router.push({
          path: '/home/o_list',
          query: {
            status: status
          }
        });
        let index = -1;
        index = this.rightTabsContent.findIndex(item => {
          return item.title === '细化订单列表';
        });
        if (index === -1) {
          this.rightTabsContent.push({
            title: '细化订单列表',
            name: '/home/o_list',
            content: this.$route.fullPath
          });
        } else {
          this.rightTabsContent.splice(index, 1, {
            title: '细化订单列表',
            name: '/home/o_list',
            content: this.$route.fullPath
          });
        }
        this.rightTabsPosition = '/home/o_list';
        this.$store.commit('updateTabs', this.rightTabsContent);
        this.$store.commit('updateTabsPosition', this.rightTabsPosition);
      },

      // 售后单  status  2=待受理  3=待退货  4=待收货  5=待退款  6=拒绝售后  7=售后成功  8=售后关闭
      toAfterSalesOrder(status) {
        this.$router.push({
          path: '/home/as_list',
          query: {
            status: status
          }
        });
        let index = -1;
        index = this.rightTabsContent.findIndex(item => {
          return item.title === '售后列表';
        });
        if (index === -1) {
          this.rightTabsContent.push({
            title: '售后列表',
            name: '/home/as_list',
            content: this.$route.fullPath
          });
        } else {
          this.rightTabsContent.splice(index, 1, {
            title: '售后列表',
            name: '/home/as_list',
            content: this.$route.fullPath
          });
        }
        this.$store.commit('updateTabs', this.rightTabsContent);
        this.$store.commit('updateTabsPosition', '/home/as_list');
      },

      // 申诉工单  status  1=待提交  2=待审核  3=已完成  4=拒绝受理
      toComplaintOrder(status) {
        this.$router.push({
          path: '/home/complaint_order',
          query: {
            status: status
          }
        });
        let index = -1;
        index = this.rightTabsContent.findIndex(item => {
          return item.title === '申诉工单管理';
        });
        if (index === -1) {
          this.rightTabsContent.push({
            title: '申诉工单管理',
            name: '/home/complaint_order',
            content: this.$route.fullPath
          });
        } else {
          this.rightTabsContent.splice(index, 1, {
            title: '申诉工单管理',
            name: '/home/complaint_order',
            content: this.$route.fullPath
          });
        }
        this.rightTabsPosition = '/home/complaint_order';
        this.$store.commit('updateTabs', this.rightTabsContent);
        this.$store.commit('updateTabsPosition', this.rightTabsPosition);
      },

      // 平台公告
      toPlatformList(id, title) {
        this.$router.push({
          path: '/home/p_list',
          query: {
            id: id,
            title: title
          }
        });
        let index = -1;
        index = this.rightTabsContent.findIndex(item => {
          return item.title === '平台公告列表';
        });
        if (index === -1) {
          this.rightTabsContent.push({
            title: '平台公告列表',
            name: '/home/p_list',
            content: this.$route.fullPath
          });
        } else {
          this.rightTabsContent.splice(index, 1, {
            title: '平台公告列表',
            name: '/home/p_list',
            content: this.$route.fullPath
          });
        }
        this.rightTabsPosition = '/home/p_list';
        this.$store.commit('updateTabs', this.rightTabsContent);
        this.$store.commit('updateTabsPosition', this.rightTabsPosition);
      },

      // 供应山公告
      toSupplierList(id, title) {
        this.$router.push({
          path: '/home/s_list',
          query: {
            id: id,
            title: title
          }
        });
        let index = -1;
        index = this.rightTabsContent.findIndex(item => {
          return item.title === '供应商公告列表';
        });
        if (index === -1) {
          this.rightTabsContent.push({
            title: '供应商公告列表',
            name: '/home/s_list',
            content: this.$route.fullPath
          });
        } else {
          this.rightTabsContent.splice(index, 1, {
            title: '供应商公告列表',
            name: '/home/s_list',
            content: this.$route.fullPath
          });
        }
        this.rightTabsPosition = '/home/s_list';
        this.$store.commit('updateTabs', this.rightTabsContent);
        this.$store.commit('updateTabsPosition', this.rightTabsPosition);
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          this.getAgentMainInfo();
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      // 获取登录后用户名
      this.userName = sessionStorage.getItem('userName');
      this.getAgentMainInfo();
    },
    activated() {
      this.getAgentMainInfo();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/home-view";

  .home_index {
    width: calc(100% - 10px);
    height: calc(100% - 10px);
    padding: 5px;
    background-color: $cfff;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;

    .home_index_msg {
      width: 100%;
      height: 100%;
      /*border: 1px solid #6f7180;*/
    }

    .home_index_first {
      /*background-color: #dddddd;*/
      box-shadow: 0 0 5px 3px #ddd;
      width: 93%;
      margin: 10px auto 0;
      padding: 10px 20px;
      display: flex;
      align-items: center;

      .home_index_img {
        display: inline-block;

        img {
          width: 200px;
          height: 200px;
        }
      }

      .home_index_account {
        display: inline-block;
      }
    }

    .home_index_second {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
      padding: 15px 25px;
      /*border: 1px solid #d3d4d6;*/

      .home_index_second_left, .home_index_second_right {
        /*display: inline-block;*/
        width: 47%;
        display: flex;
        align-items: center;
        border: 1px solid #dddddd;

        .arrow {
          width: 200px;
          height: 200px;
          line-height: 200px;
          text-align: center;
          font-size: 32px;
          /*background-color: #eeeeee;*/
          margin-right: 10px;
          /*color: #fff;*/
        }

        .arrow_left {
          background-image: url("../../assets/img/order.jpg");
        }

        .arrow_right {
          background-image: url("../../assets/img/pg_aftersales.jpg");
        }

        span {
          display: inline-block;
          width: 118px;
          text-align: right;
          margin-right: 10px;
          margin-bottom: 15px;
        }
      }
    }

    .home_index_third {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;

      .home_index_third_left, .home_index_third_right {
        display: inline-block;
        width: 49%;
        border: 1px solid #908b8b;
        position: relative;
        border-radius: 13px;

        .title {
          padding: 10px 30px;
          /*margin: 10px 30px;*/
          border-bottom: 1px solid #000;
        }

        ul {
          height: 180px;
          overflow-y: auto;

          li {
            padding: 10px 35px;

            &:hover {
              cursor: pointer;
              color: #2D8CF0;
              background-color: #eeeeee;
            }
          }
        }

        .left_top {
          position: absolute;
          top: -31px;
          left: -31px;
          width: 30px;
          height: 0;
          border-top: 30px transparent solid;
          border-right: 30px rgba(0, 0, 0, 3) solid;
          border-bottom: 30px transparent solid;
          transform: rotate(45deg);
        }

        .right_top {
          position: absolute;
          top: -31px;
          right: -31px;
          width: 30px;
          height: 0;
          border-top: 30px transparent solid;
          border-right: 30px rgba(0, 0, 0, 3) solid;
          border-bottom: 30px transparent solid;
          transform: rotate(135deg);
        }

        .left_bottom {
          position: absolute;
          bottom: -31px;
          left: -31px;
          width: 30px;
          height: 0;
          border-top: 30px transparent solid;
          border-right: 30px rgba(0, 0, 0, 3) solid;
          border-bottom: 30px transparent solid;
          transform: rotate(-45deg);
        }

        .right_bottom {
          position: absolute;
          bottom: -31px;
          right: -31px;
          width: 30px;
          height: 0;
          border-top: 30px transparent solid;
          border-right: 30px rgba(0, 0, 0, 3) solid;
          border-bottom: 30px transparent solid;
          transform: rotate(-135deg);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/index.vue